import type { ReactNode } from 'react'

export const BenefitIcon = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex size-[36px] items-center justify-center rounded-xs bg-primary-main/[0.12] p-2 text-primary-main">
      {children}
    </div>
  )
}
